// Alaska Airlines Javascript
var Alaska = {};

Alaska.$ = function (id) { return document.getElementById(id); }

Alaska.setup = function () {
    //Safari fixes
    if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
        var viewportmeta = document.querySelector('meta[name="viewport"]');
        if (viewportmeta) {
            viewportmeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0';
            document.body.addEventListener('gesturestart', function () {
                viewportmeta.content = 'width=device-width, minimum-scale=0.25, maximum-scale=1.6';
            }, false);
        }
    }
}

Alaska.drop = function () {
    var dropEls = Alaska.util.getElementsByClassName('drop-head');
    for (var i = 0; i < dropEls.length; i++) {
        (function (value) {
            var currentDrop = dropEls[value];
            var dropCont = currentDrop.parentNode;
            Alaska.util.listenEvent(currentDrop, 'click', function () {
                if (Alaska.util.hasClass(dropCont, 'open')) {
                    Alaska.util.removeClass(dropCont, 'open');
                } else {
                    Alaska.util.addClass(dropCont, 'open');
                }
            });
        } (i));
    }
}

Alaska.collapse = function () {
    var collapseElements = document.querySelectorAll('.collapse');
    for (var i = 0; i < collapseElements.length; i++) {
        (function (value) {
            var collapseElement = collapseElements[value];
            var childActionElements = Alaska.util.getElementsByClassName('collapse-action', null, collapseElement);

            for (var j = 0; j < childActionElements.length; j++) {
                var currentActionElement = childActionElements[j];
                Alaska.util.listenEvent(currentActionElement, 'click', function () {
                    if (Alaska.util.hasClass(collapseElement, 'open')) {
                        Alaska.util.removeClass(collapseElement, 'open');
                    } else {
                        Alaska.util.addClass(collapseElement, 'open');
                    }
                });
            }
        }(i));
    }
}


Alaska.persistentDrop = function () {
    var dropHead = Alaska.$('bp-drop'),
		dropBody = Alaska.$('bp-drop-content');
    Alaska.util.listenEvent(dropHead, 'click', function () {
        if (Alaska.util.hasClass(dropBody, 'open')) {
            Alaska.util.removeClass(dropBody, 'open');
        } else {
            Alaska.util.addClass(dropBody, 'open');
        }
    })
}

Alaska.toggleRadio = function (target) {
    if (target.className.match(/\bcurrent\b/) === null) {
        var tabs = target.parentNode.getElementsByTagName("label");
        for (var i = 0; i < tabs.length; i++) {
            Alaska.util.removeClass(tabs[i], "current");
        }
        Alaska.util.addClass(target, "current");
        if (target.childNodes[0].className.match(/select[^\s]+/g)) {
            var wrapper = Alaska.util.getParentByTagName(target, "fieldset"),
				oldContent = Alaska.util.getElementsByClassName('toggle', 'div', wrapper);
            for (i = 0; i < oldContent.length; i++) {
                oldContent[i].style.display = "none";
            }
            //Modified by AS - Jira bug submitted
            var classes = target.childNodes[0].className.split(' ');
            for (i = 0; i < classes.length; i++) {
                var divID = classes[i].match(/select[^\s]+/g).toString(), newContent = Alaska.$(divID);
                newContent.style.display = "block";
            }
        }
    }
    else {
        return false;
    }
}

Alaska.toggleRadioList = function (target, id) {
    target.childNodes[1].setAttribute('checked', 'checked');
    Alaska.toggleRadio(target);
}

Alaska.modal = {

    init: function (modalClass, heading, dialogue, cancel, confirm, action, link) {
        var triggers = Alaska.util.getElementsByClassName(modalClass),
			i = 0,
			max = triggers.length;
        for (; i < max; i += 1) {
            Alaska.util.listenEvent(triggers[i], 'click', function (event) {
                event.preventDefault();
                if (link) {
                    Alaska.modal.addLinkModal(link, heading, dialogue, cancel, confirm);
                } else {
                    var form = Alaska.util.getParentByTagName(event.target, "form");
                    Alaska.modal.add(form, heading, dialogue, cancel, confirm, action);
                }
            });
        }
    },

    addStaticModal: function (heading, dialogue, buttonText) {
        var background = document.createElement('div'),
            dialog = document.createElement('div'),
            docHeight = Alaska.util.getDocumentHeight();

        buttonText = typeof buttonText !== 'undefined' ? buttonText : "Close";
        background.setAttribute('class', 'disable-ui');
        background.setAttribute('id', 'modal-background');
        background.setAttribute('style', 'height: ' + docHeight + 'px;');
        dialog.setAttribute('id', 'modal-window');
        if (heading != null) {
            dialog.innerHTML = '<h2 style="font-weight:bold">' + heading + '</h2>'
        }
        dialog.innerHTML += dialogue + '<div class="form-row last"><input type="button" class="button" id="dialog-cancel" value="' + buttonText + '"></div>';
        background.appendChild(dialog);
        document.body.appendChild(background);
        dialog.setAttribute('style', 'top: ' + Alaska.modal.calculateTop(dialog) + ';'); //set this here after content/innerHTML height is established
        Alaska.modal.addLinkHandlers();
    },

    addNewStaticModal: function (heading, body) {
        var background = document.createElement('div'),
            dialog = document.createElement('div'),
            content = document.createElement('div'),
			docHeight = Alaska.util.getDocumentHeight();

        background.setAttribute('class', 'disable-ui');
        background.setAttribute('id', 'modal-background');
        background.setAttribute('style', 'height: ' + docHeight + 'px;');
        dialog.setAttribute('id', 'new-modal-window');
        content.setAttribute('id', 'new-modal-content');
        
        dialog.innerHTML = '<div id="new-modal-header"><div id="new-modal-header-image"><input type="image" src="/images/modal_close.png" id="dialog-cancel"></div></div>';

        if (heading != null) {
            content.innerHTML = '<h2>' + heading + '</h2>';
        }
        content.innerHTML += body;
        dialog.appendChild(content);
        background.appendChild(dialog);
        document.body.appendChild(background);   
        Alaska.modal.addLinkHandlers();
    },

    addLinkModal: function (link, heading, dialogue, cancel, confirm) {
        var background = document.createElement('div'),
			dialog = document.createElement('div'),
			docHeight = Alaska.util.getDocumentHeight();

        background.setAttribute('class', 'disable-ui');
        background.setAttribute('id', 'modal-background');
        background.setAttribute('style', 'height: ' + docHeight + 'px;');
        dialog.setAttribute('id', 'modal-window');
        dialog.innerHTML = '<h2 style="font-weight:bold">' + heading + '</h2>' + dialogue + '<div class="form-row last"><a class="button-link secondary" id="dialog-cancel">' + cancel + '</a><a href="' + link + '" class="button-link" id="dialog-submit">' + confirm + '</a></div>';
        background.appendChild(dialog);
        document.body.appendChild(background);
        dialog.setAttribute('style', 'top: ' + Alaska.modal.calculateTop(dialog) + ';'); //set this here after content/innerHTML height is established
        Alaska.modal.addLinkHandlers();
    },

    addRedirectModal: function (redirectTo, heading, dialogue) {
        var background = document.createElement('div'),
			dialog = document.createElement('div'),
			docHeight = Alaska.util.getDocumentHeight();

        background.setAttribute('class', 'disable-ui');
        background.setAttribute('id', 'modal-background');
        background.setAttribute('style', 'height: ' + docHeight + 'px;');
        dialog.setAttribute('id', 'modal-window');
        dialog.innerHTML = '<h2 style="font-weight:bold">' + heading + '</h2>' + dialogue + '<div class="form-row last"><a href="' + redirectTo + '" class="button-link" style="width:100%" id="dialog-redirect">Close</a></div>';
        background.appendChild(dialog);
        document.body.appendChild(background);
        dialog.setAttribute('style', 'top: ' + Alaska.modal.calculateTop(dialog) + ';'); //set this here after content/innerHTML height is established
        Alaska.modal.addRedirectHandlers();
    },

    addConfirmationModal: function (heading, dialogue, cancelText, confirmText, confirmCallback, cancelCallback, callbackArgs) {
        var background = document.createElement('div'),
            dialog = document.createElement('div'),
            docHeight = Alaska.util.getDocumentHeight();

        background.setAttribute('class', 'disable-ui');
        background.setAttribute('id', 'modal-background');
        background.setAttribute('style', 'height: ' + docHeight + 'px;');
        dialog.setAttribute('id', 'modal-window');
        dialog.innerHTML = '<h2 style="font-weight:bold">' + heading + '</h2>' + dialogue + '<div class="form-row last"><a class="button-link" id="dialog-confirm">' + confirmText + '</a><a class="button-link secondary" id="dialog-cancel">' + cancelText + '</a></div>';
        background.appendChild(dialog);
        document.body.appendChild(background);
        dialog.setAttribute('style', 'top: ' + Alaska.modal.calculateTop(dialog) + ';'); //set this here after content/innerHTML height is established
        Alaska.modal.addConfirmationHandlers(confirmCallback, cancelCallback, callbackArgs);
	},

    addConfirmationOkModal: function (dialogue, confirmText, confirmCallback, callbackArgs) {
	    var background = document.createElement('div'),
		    dialog = document.createElement('div'),
		    docHeight = Alaska.util.getDocumentHeight();

	    background.setAttribute('class', 'disable-ui');
	    background.setAttribute('id', 'modal-background');
	    background.setAttribute('style', 'height: ' + docHeight + 'px;');
	    dialog.setAttribute('id', 'modal-window');
	    dialog.innerHTML = dialogue + '<div class="form-row last"><a class="button-link" id="dialog-confirm">' + confirmText + '</div >';
	    background.appendChild(dialog);
	    document.body.appendChild(background);
	    dialog.setAttribute('style', 'top: ' + Alaska.modal.calculateTop(dialog) + ';'); //set this here after content/innerHTML height is established
		Alaska.modal.addConfirmationOkHandlers(confirmCallback, callbackArgs);
    },

    addConfirmationOkHandlers: function (confirmCallback, callbackArgs) {
	    var confirmElement = Alaska.$('dialog-confirm');

	    if (confirmElement) {
		    Alaska.util.listenEvent(confirmElement,
			    'click',
			    function() {
				    Alaska.modal.remove();

				    if (confirmCallback) {
					    confirmCallback(callbackArgs);
				    }
			    });
	    }
    },

    add: function (form, heading, dialogue, cancel, confirm, action) {
        var background = document.createElement('div'),
			dialog = document.createElement('div'),
			docHeight = Alaska.util.getDocumentHeight();
        background.setAttribute('class', 'disable-ui');
        background.setAttribute('id', 'modal-background');
        background.setAttribute('style', 'height: ' + docHeight + 'px;');
        dialog.setAttribute('id', 'modal-window');
        dialog.innerHTML = '<h2 style="font-weight:bold">' + heading + '</h2>' + dialogue + '<div class="form-row last"><input type="button" class="button secondary" id="dialog-cancel" value="' + cancel + '"><input type="submit" class="button" id="dialog-submit" value="' + confirm + '"></div>';
        form.setAttribute("action", action);
        background.appendChild(dialog);
        document.body.appendChild(background);
        dialog.setAttribute('style', 'top: ' + Alaska.modal.calculateTop(dialog) + ';'); //set this here after content/innerHTML height is established
        Alaska.modal.addDialogHandlers(form);
    },

    addConfirmRejectModal: function (form, heading, dialogue, cancel,confirm, action) {
        var background = document.createElement('div'),
            dialog = document.createElement('div'),
            docHeight = Alaska.util.getDocumentHeight();
        background.setAttribute('class', 'disable-ui');
        background.setAttribute('id', 'modal-background');
        background.setAttribute('style', 'height: ' + docHeight + 'px;');
        dialog.setAttribute('id', 'modal-window');
        dialog.innerHTML = '<h2 style="font-weight:bold">' + heading + '</h2>' + dialogue + '<div class="form-row last"><input type="submit" class="button" id="dialog-submit" value="' + confirm + '"><input type="button" class="button secondary" id="dialog-cancel" value="' + cancel + '"></div>';
        form.setAttribute("action", action);
        background.appendChild(dialog);
        document.body.appendChild(background);
        dialog.setAttribute('style', 'top: ' + Alaska.modal.calculateTop(dialog) + ';'); //set this here after content/innerHTML height is established
        Alaska.modal.addDialogHandlers(form);
    },
    show: function(dialogbody) {
        var background = document.createElement('div'),
			dialog = document.createElement('div'),
			docHeight = Alaska.util.getDocumentHeight(),
            tmp = document.createElement("div");
        tmp.appendChild(dialogbody.cloneNode(true));
        background.setAttribute('class', 'disable-ui');
        background.setAttribute('id', 'modal-background');
        background.setAttribute('style', 'height: ' + docHeight + 'px;');
        dialog.setAttribute('id', 'modal-window');
        dialog.innerHTML= tmp.innerHTML;
        background.appendChild(dialog);
        document.body.insertBefore(background, document.body.childNodes[0]);
        dialog.setAttribute('style', 'top: ' + Alaska.modal.calculateTop(dialog) + ';');
    },

    showSeatUpgrade: function(dialogbody, isPc, isCheckin){
        var background = document.createElement('div'),
			dialog = document.createElement('div'),
			docHeight = Alaska.util.getDocumentHeight(),
            tmp = document.createElement("div");
        tmp.appendChild(dialogbody.cloneNode(true));
        background.setAttribute('class', 'disable-ui');
        background.setAttribute('id', 'modal-background');
        background.setAttribute('style', 'height: ' + docHeight + 'px;');
        dialog.setAttribute('id', 'modal-window-no-padding');
        dialog.innerHTML = tmp.innerHTML;
        background.appendChild(dialog);
        document.body.insertBefore(background, document.body.childNodes[0]);
        dialog.setAttribute('style', 'top: ' + Alaska.modal.calculateTop(dialog) + ';');
        var closeBtn = dialog.querySelector('button');
        Alaska.util.listenEvent(closeBtn, 'click', function () {
            Alaska.modal.remove();
            var prop3prefix = isCheckin ? 'Checkin' : 'Seats';
            var prop3 = prop3prefix + ':UpgradetoPremiumClass:Close';
            if (!isPc) {
                prop3 = prop3prefix + ':UpgradetoPreferredPlus:Close';
            }
            Alaska.omniture.reportClick(prop3);
        });
    },

    remove: function () {
        window.removeEventListener("resize", Alaska.modal.reCalc);
        document.body.removeChild(Alaska.$('modal-background'));
    },

    calculateTop: function (theDiv) {
        var currentTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop,
			currentHeight = window.innerHeight,
			midpoint = (currentHeight / 2) + currentTop,
            topPosition = 0;
        if (theDiv) {
            topPosition = midpoint - theDiv.clientHeight / 2;
        } else {
            topPosition = midpoint - 75; // 75 is half the height of the dialog box
        }

        return topPosition + 'px';
    },

    calculateLeft: function () {
        var leftPosition = (window.innerWidth / 2) - 144; // 144 is half the width of the dialog box
        return leftPosition + 'px';
    },

    reCalc: function () {
        Alaska.$("modal-window").setAttribute('style', 'top: ' + Alaska.modal.calculateTop(Alaska.$('modal-window')) + '; left: ' + Alaska.modal.calculateLeft());
    },

    addDialogHandlers: function (form) {
        var cancel = Alaska.$('dialog-cancel'),
			submit = Alaska.$('dialog-submit');
        if (cancel) {
            Alaska.util.listenEvent(cancel, 'click', function () {
                Alaska.modal.remove();
            });
        }
        if (submit) {
            Alaska.util.listenEvent(submit, 'click', function () {
                form.submit();
            })
        }
    },

    addRedirectHandlers: function () {
        var redirect = Alaska.$('dialog-redirect');
        Alaska.util.listenEvent(redirect, 'click', function () {
            window.location = redirect.getAttribute('href');
        });
    },

    addConfirmationHandlers: function (confirmCallback, cancelCallback, callbackArgs) {
        var cancelElement = Alaska.$('dialog-cancel'),
            confirmElement = Alaska.$('dialog-confirm');
        if (cancelElement) {
            Alaska.util.listenEvent(cancelElement, 'click', function () {
                Alaska.modal.remove();

                if (cancelCallback) {
                    cancelCallback(callbackArgs);
                }
            });
        }
        if (confirmElement) {
            Alaska.util.listenEvent(confirmElement, 'click', function () {
                Alaska.modal.remove();

                if (confirmCallback) {
                    confirmCallback(callbackArgs);
                }
            })
        }
    },
    
    addLinkHandlers: function () {
        Alaska.util.listenEvent(Alaska.$('dialog-cancel'), 'click', function () {
            Alaska.modal.remove();
        });
    }

};

Alaska.omniture = {
    reportClick: function(prop3) {
        if (s_gi) {
            var s = s_gi(s_account);
            s.linkTrackVars = 'prop3';
            s.linkTrackEvents = 'None';
            s.prop3 = prop3;
            s.tl(true, 'o', prop3);
            s.prop3 = '';
        }

        Alaska.analytics.dispatchEvent({
            link_name: prop3,
            link_tracking: prop3,
            link_type: 'o'
        })
    }
}

Alaska.analytics = {
    dispatchEvent: function (payload) {
        var sanitizedOutput;
        try {
            if (typeof payload === "string") {
                sanitizedOutput = JSON.parse(payload);
            } else if (typeof payload === "object") {
                sanitizedOutput = payload;
            }
        } catch (e) {
            return;
        }

        if (!sanitizedOutput) return;

        document.dispatchEvent(new CustomEvent('aag-analytics:event', {
            detail: payload
        }));
    }
}

Alaska.spinner = {

    show: function (alwaysShow) {
        if (alwaysShow || (!Alaska.util.userAgentContain('Android 2.') && !Alaska.util.userAgentContain('ALKApp'))) {
            var aSpinner = Alaska.$("aSpinner");
            if (aSpinner) {
                aSpinner.style.top = Alaska.spinner.calcTop(46);
                aSpinner.style.left = Alaska.spinner.calcLeft(44);
                var spinCnt = Alaska.$("spinner-cnt");
                spinCnt.style.height = Alaska.util.getDocumentHeight() + "px";
                spinCnt.style.display = 'block';
            }
        }
    },

    calcTop: function (sHeight) {
        var currentTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop,
			midpoint = (window.innerHeight / 2) + currentTop,
			topPosition = midpoint - sHeight / 2;
        return topPosition + 'px';
    },

    calcLeft: function (sWidth) {
        var leftPosition = (window.innerWidth / 2) - sWidth / 2;
        return leftPosition + 'px';
    },

    hide: function () {
        var c = Alaska.$("spinner-cnt");
        if (c) {
            c.style.display = 'none';
        }
    }
};

//Function modified by AS
Alaska.calculateBagFees = function () {
    var bagFees = Alaska.util.getElementsByClassName('bag-fee');
    if (bagFees.length > 0) {
        var bagFeesTotal = 0;
        for (var i = 0; i < bagFees.length; i++) {
            var currentBag = bagFees[i];
            if (currentBag) {
                var currentBagText = currentBag.options[currentBag.selectedIndex].text;
                var textArr = currentBagText.split('$');
                if (textArr.length > 1) {
                    bagFeesTotal += parseFloat(textArr[1]);
                }
            }
        }
        var newTotal = document.createTextNode('$' + bagFeesTotal.toFixed(2));
        var totalDd = Alaska.$('bag-fees-total');
        totalDd.replaceChild(newTotal, totalDd.childNodes[0]);        

        let hasBags = false;
        for (var i = 0; i < bagFees.length; i++) {
            for (var x = 0; x < bagFees[i].options.length; x++) {
                var option = bagFees[i].options[x];
                if (option.selected && parseInt(option.value) > 0) {
                    hasBags = true;
                    break;
                }
            }
        }

        var continueButton = Alaska.$("continue-button");
        continueButton.value = !hasBags ? "NO BAGS OR PAY AT AIRPORT" : bagFeesTotal > 0 ? "PAY FOR BAGS" : "CONTINUE";  
    }
}

//Function modified by AS
Alaska.initBags = function () {
    var bagFees = Alaska.util.getElementsByClassName('bag-fee');
    for (var i = 0; i < bagFees.length; i++) {
        (function (value) {
            var currentBag = bagFees[i];
            if (currentBag) {
                Alaska.util.listenEvent(currentBag, 'change', Alaska.calculateBagFees);
            }
        } (i));
    }
}

Alaska.clearTxt = function (item) {
    var box = item.parentNode.getElementsByTagName("input")[0];
    box.value = "";
    box.focus();
}

Alaska.buildInputSelections = function (dataText, inputID, optionalClickDelegate) {
    var list = document.createElement('ol');
    var geoInput = Alaska.$(inputID);
    var geoWrap = geoInput.parentNode.parentNode;
    list.setAttribute('class', 'input-selections');
    list.setAttribute('id', 'input-selections-' + inputID);
    for (var i = 0; i < dataText.length; i++) {
        var currentData = dataText[i];
        var listItem = document.createElement('li');
        var text = document.createTextNode(currentData);
        listItem.appendChild(text);
        listItem.setAttribute('data-value', dataText[i]);
        listItem.setAttribute('class', 'input-selection');
        if (i == (dataText.length - 1)) {
            listItem.setAttribute('class', 'last');
        }
        list.appendChild(listItem);
    }
    Alaska.util.addClass(geoInput, 'geo-active');
    geoWrap.appendChild(list);
    var selectionList = Alaska.$('input-selections-' + inputID);
    var selectionItems = selectionList.getElementsByTagName('li');

    var checkRemove = function (event) {
        if ((event.target !== Alaska.$('input-selections-' + inputID)) || (Alaska.util.hasClass(event.target, 'input-selection'))) {
            event.stopPropagation();
            Alaska.removeInputSelections(inputID);
        }
    }

    Alaska.util.listenEvent(document.body, 'click', checkRemove);

    for (var j = 0; j < selectionItems.length; j++) {
        (function (value) {
            var currentItem = selectionItems[value];
            Alaska.util.listenEvent(currentItem, 'click', function () {
                //var selectedText = currentItem.text;
                var selectedValue = currentItem.getAttribute('data-value');
                geoInput.value = selectedValue;
                selectionList.parentNode.removeChild(selectionList);
                Alaska.util.removeClass(geoInput, 'geo-active');
                if (typeof optionalClickDelegate != "undefined") {
                    optionalClickDelegate(selectedValue);
                }
            });
        } (j));
    }
}

//Function modified by AS - new code has been pasted in Jira
Alaska.updateInputSelections = function (data, inputID) {
    var selectionList = Alaska.$('input-selections-' + inputID);
    var selectionItems = selectionList.getElementsByTagName('li');

    if (selectionItems.length != data.length && (data.length - selectionItems.length) > 0) {
        for (var i = selectionItems.length - 1; i < data.length; i++) {
            var listItem = document.createElement('li');
            var text = document.createTextNode(data[i]);
            listItem.appendChild(text);
            listItem.setAttribute('data-value', data[i]);
            listItem.setAttribute('class', 'input-selection');
            if (i == (data.length - 1)) {
                listItem.setAttribute('class', 'last');
            }
            selectionItems[i].parentNode.appendChild(listItem);
        }
    }

    for (var j = 0; j < data.length; j++) {
        var currentData = data[j];
        selectionItems[j].innerHTML = currentData;
        selectionItems[j].setAttribute('data-value', currentData);
        if (Alaska.util.hasClass(selectionItems[j], 'last')) {
            Alaska.util.removeClass(selectionItems[j], 'last');
        }
        if (j == (data.length - 1)) {
            Alaska.util.addClass(selectionItems[j], 'last');
        }
    }
    var itemsLength = selectionItems.length
    for (j = (itemsLength - 1); j >= data.length; j--) {
        selectionItems[j].parentNode.removeChild(selectionItems[j]);
    }
}

Alaska.removeInputSelections = function (inputID) {
    if (Alaska.$('input-selections-' + inputID)) {
        var geoInput = Alaska.$(inputID);
        var selectionList = Alaska.$('input-selections-' + inputID);
        var selectionParent = selectionList.parentNode;
        selectionParent.removeChild(selectionList);
        Alaska.util.removeClass(geoInput, 'geo-active');
    }
}

Alaska.predictASPub = function () {
    Alaska.predict(this.id, "ASPublished");
}
Alaska.predictCheckin = function () {
    Alaska.predict(this.id, "Checkin");
}

Alaska.predictVars = {
    curTime: 0,
    delayTime : 300,
    predictCalled: false,
    lastCalledValue : ""
};


Alaska.predict = function (inputID, typeOfCities) {
    clearTimeout(Alaska.predict.timer);
    Alaska.predict.timer = setTimeout(function () {
        Alaska.predictAjax(inputID, typeOfCities);
    }, Alaska.predictVars.delayTime);
}

Alaska.predict.timer = null;

Alaska.predictAjax = function (inputID, typeOfCities) {
    var inputValue = Alaska.$(inputID).value.trim();
    var validChars = /^[a-z ]*$/i.test(inputValue);
    if (getXHR() && inputValue != "" && validChars) {
        req.open('POST', "/cities/" + typeOfCities + "CitiesByPrefix?prefix=" + inputValue, true);
        req.onreadystatechange = function () {
            Alaska.predictVars.predictCalled = false;
            if (req.readyState == 4) {
                if (req.status == 200) {
                    var data;
                    try {
                        data = JSON.parse(JSON.parse(req.responseText).msg);
                    } catch (e) {
                        data = null;
                    }

                    if (data !== null && !Alaska.$('input-selections-' + inputID)) {
                        Alaska.buildInputSelections(data, inputID);
                    }
                    else if (data === null) {
                        Alaska.removeInputSelections(inputID);
                    }
                    else {
                        Alaska.updateInputSelections(data, inputID);
                    }
                }
            }
        }
        req.send('');
    } else {
        if (Alaska.$('input-selections-' + inputID)) {
            Alaska.removeInputSelections(inputID);
        }   
    }
}

Alaska.geoASPub = function () {
    Alaska.geo(this.id, "ASPublished");
}

Alaska.geoCheckin = function () {
    Alaska.geo(this.id, "Checkin");
}
Alaska.geo = function (controlId, typeOfCities) {
    controlId = controlId.replace("-button", ""); //TODO: William - This is not ideal, but it will work for now.
    navigator.geolocation.getCurrentPosition(
		function (position) {
		    if (getXHR()) {
		        req.open('POST', "/cities/" + typeOfCities + "CitiesByLocation?longitude=" + position.coords.longitude + "&latitude=" + position.coords.latitude, true);
		        req.onreadystatechange = function () {
		            if (req.readyState == 4) {
		                if (req.status == 200) {
		                    var json = JSON.parse(req.responseText);
		                    if (json.msg) {
		                        Alaska.util.showClientMsg(json.msg);
		                    }
		                    else {
		                        var data = JSON.parse(json.results);
		                        Alaska.buildInputSelections(data, controlId);
		                    }
		                }
		                else {
		                    Alaska.util.showClientMsg("There are no airports near your current location that are served by Alaska Airlines.");
		                }
		            }
		        }
		        req.send('');
		    }
		}
	,
		function (error) {
		    var errMsg = "";

		    switch (error.code) {
		        case error.TIMEOUT:
		            errMsg = 'Request Timeout. Please try again.';
		            break;
		        case error.POSITION_UNAVAILABLE:
		            errMsg = 'Your current location is not available at this time.';
		            break;
		        case error.PERMISSION_DENIED:
		            errMsg = 'Please enable location services on your device.';
		            break;
		        case error.UNKNOWN_ERROR:
		            errMsg = 'Unknown error. Please try again.';
		            break;
		    }

		    Alaska.util.showClientMsg(errMsg);
		}
	);
}

//Function modified by AS
Alaska.updatePaymentOptions = function () {
    var dropdown = Alaska.$('CreditCard_Id');
    var popCC = function () {
        if (storedcc) {
            var card = Alaska.$("CCNum_Div");
            if (!hasModelError) {
                if (dropdown.value == "" || dropdown.value == "NEW") {
                    Alaska.$("CreditCard_NameOnCard").value = "";
                    Alaska.$("CreditCard_Number").value = "";
                    Alaska.$("CreditCard_ExpirationMonth").value = "";
                    Alaska.$("CreditCard_ExpirationYear").value = "";
                    if (Alaska.$("CreditCard_CardType"))
                        Alaska.$("CreditCard_CardType").value = "";
                    if (Alaska.$("CreditCard_HasStoredNumber"))
                        Alaska.$("CreditCard_HasStoredNumber").value = "false";
                    card.style.display = "block";
                }
                else {
                    for (var i = 0; i < storedcc.length; i++) {
                        if (storedcc[i].Id == dropdown.value) {
                            Alaska.$("CreditCard_NameOnCard").value = storedcc[i].NameOnCard;
                            Alaska.$("CreditCard_Number").value = storedcc[i].Number;
                            Alaska.$("CreditCard_ExpirationMonth").value = storedcc[i].ExpirationMonth;
                            Alaska.$("CreditCard_ExpirationYear").value = storedcc[i].ExpirationYear;
                            if (Alaska.$("CreditCard_CardType"))
                                Alaska.$("CreditCard_CardType").value = storedcc[i].CardType;
                            if (Alaska.$("CreditCard_HasStoredNumber"))
                                Alaska.$("CreditCard_HasStoredNumber").value = storedcc[i].HasStoredNumber;
                            if (dropdown[dropdown.selectedIndex].text.indexOf("(****") == -1 || dropdown[dropdown.selectedIndex].text.indexOf("(****)") > -1) {
                                card.style.display = "block";
                            } else {
                                card.style.display = "none";
                            }
                        }
                    }
                }
            } else {
                if (dropdown[dropdown.selectedIndex].text.indexOf("(****") == -1 || dropdown[dropdown.selectedIndex].text.indexOf("(****)") > -1) {
                    card.style.display = "block";
                } else {
                    card.style.display = "none";
                }
            }
        }
    }
    var dropdownPhone = Alaska.$('PhoneNumberDropdown');
    var changePhone = function (event) {
        //            if (hasPhoneNumberError == "True")
        //                dropdownPhone.value = "NEW";
        var countrycode = Alaska.$('country-code');
        var phonenumber = Alaska.$('phone-number');
        if (dropdownPhone.value == "NEW") {
            countrycode.style.display = phonenumber.style.display = "block";
            //                if (hasPhoneNumberError == "False" && !firstLoad) {
            if (!hasModelError) {
                Alaska.$('PaymentPhoneNumber_CountryCode').value = "1";
                Alaska.$('PaymentPhoneNumber_Number').value = "";
            }
            //                }
        } else
            countrycode.style.display = phonenumber.style.display = "none";
    }
    if (dropdown) {
        Alaska.util.listenEvent(dropdown, 'change', function (event) {
            event.preventDefault();
            popCC();
        });
        popCC();
    }
    if (dropdownPhone) {
        Alaska.util.listenEvent(dropdownPhone, 'change', function (event) {
            event.preventDefault();
            changePhone();
        });
        changePhone();
    } else {
        var countryCode = Alaska.$('country-code'),
            phoneNumber = Alaska.$('phone-number');
        if (countryCode && phoneNumber) {
            Alaska.$('country-code').style.display = Alaska.$('phone-number').style.display = "block";
        }
    }
    // set in .cshtml based on view model
    hasModelError = false;
}

//This function is use on booking payment & bag/FC upgrade payment pages. Please test all if you make a change
Alaska.swapStates = function (code) {
    var us = Alaska.$("uslist"), ca = Alaska.$("calist"), mx = Alaska.$("mxlist"), none = Alaska.$("nonelist");

    us.style.display = "none";
    ca.style.display = "none";
    mx.style.display = "none";
    none.style.display = "none";

    us.disabled = true;
    ca.disabled = true;
    mx.disabled = true;
    none.disabled = true;

    switch (code) {
        case "US":
            us.style.display = "block";
            us.disabled = false;
            break;
        case "CA":
            ca.style.display = "block";
            ca.disabled = false;
            break;
        case "MX":
            mx.style.display = "block";
            mx.disabled = false;
            break;
        default:
            none.style.display = "block";
            none.disabled = false;
            break;
    }
}

// Utility functions
Alaska.util = {};

Alaska.util.getDocumentHeight = function () {
    var D = document;
    return Math.max(
        Math.max(D.body.scrollHeight, D.documentElement.scrollHeight),
        Math.max(D.body.offsetHeight, D.documentElement.offsetHeight),
        Math.max(D.body.clientHeight, D.documentElement.clientHeight)
    );
}

/*
Alaska.util.isDescendant = function (parent, child) {
	var node = child.parentNode;
	while (node != null) {
		if (node == parent) {
			return true;
		}
		node = node.parentNode;
	}
	return false;
}
*/

Alaska.util.getParentByTagName = function (obj, tag) {
    var obj_parent = obj.parentNode;
    if (!obj_parent) return false;
    if (obj_parent.tagName.toLowerCase() == tag) {
        return obj_parent;
    }
    else {
        return Alaska.util.getParentByTagName(obj_parent, tag);
    }
}

Alaska.util.getParentByClass = function (currentElement, className) {
    while ((currentElement = currentElement.parentElement) && !currentElement.classList.contains(className));
    return currentElement;
}



Alaska.util.getElementsByClassName = function (className, tag, elm) {
    elm = elm || document;
    var elements = elm.getElementsByClassName(className),
        nodeName = (tag) ? new RegExp("\\b" + tag + "\\b", "i") : null,
        returnElements = [],
        current;
    for (var i = 0, il = elements.length; i < il; i += 1) {
        current = elements[i];
        if (!nodeName || nodeName.test(current.nodeName)) {
            returnElements.push(current);
        }
    }
    return returnElements;
};

Alaska.util.listenEvent = function (eventTarget, eventType, eventHandler) {
//    Alaska.util.removeListenEvent(eventTarget, eventType, eventHandler);
    var isAddedAlready = eventTarget.getAttribute('isEventAdded');
    if (isAddedAlready) {
        return;
    }
    if (eventTarget.addEventListener) {
        eventTarget.addEventListener(eventType, eventHandler, false);
    } else if (eventTarget.attachEvent) {
        eventType = "on" + eventType;
        eventTarget.attachEvent(eventType, eventHandler);
    } else {
        eventTarget["on" + eventType] = eventHandler;
    }
    eventTarget.setAttribute('isEventAdded', true);
}

Alaska.util.removeListenEvent = function (eventTarget, eventType, eventHandler) {
    var isAddedAlready = eventTarget.getAttribute('isEventAdded');
    if (isAddedAlready && eventTarget.removeAttribute) {
        eventTarget.removeAttribute('isEventAdded');
    }
    if (eventTarget.removeEventListener) {
        eventTarget.removeEventListener(eventType, eventHandler, false);
    } else if (eventTarget.detachEvent) {
        eventType = "on" + eventType;
        eventTarget.detachEvent(eventType, eventHandler);
    } else {
        eventTarget["on" + eventType] = null;
    }
}

Alaska.util.getEventTarget = function (e) {
    e = e || window.event;
    return e.target || e.srcElement;
}

Alaska.util.removeClass = function (element, classToRemove) {
    var currentClass = element.className;
    element.className = currentClass.replace(classToRemove, "");
}

Alaska.util.addClass = function (element, classToAdd) {
    var hasClass = element.className.indexOf(classToAdd);
    if (hasClass === -1) {
        element.className += (" " + classToAdd);
    }
}

Alaska.util.hasClass = function (element, classToFind) {
    var foundIndex = element.className.indexOf(classToFind);
    return foundIndex === -1 ? false : true;
}

Alaska.util.setCookie = function (name, value, expires) {
    //Expires given as value in ms
    var currentDate = new Date();
    var expiration = currentDate.getTime() + expires * 864000000;
    var strCookie = name + "=" + value + ";expires=" + expiration;
    document.cookie = strCookie;
}

Alaska.util.showClientMsg = function (msg) {
    var clientErrMsg = Alaska.$("client-msg-div");
    clientErrMsg.className = "server-msg-error";
    clientErrMsg.textContent = msg;
}

Alaska.util.hideClientMsg = function (msg) {
    var clientErrMsg = Alaska.$("client-msg-div");
    clientErrMsg.className = "";
    clientErrMsg.innerHTML = "";
}

/*
Alaska.util.getCookieValue = function (name) {
	var cookie = document.cookie;
	var value = document.cookie.substring(name.length + 1);
	return value;
}
*/


Alaska.util.userAgentContain = function (subString) {
    var reg = new RegExp(subString, "i");
    return reg.test(navigator.userAgent);
}

//Save selected index in fieldName
Alaska.util.saveSelectedIndex = function (list, fieldName) {
    Alaska.$(fieldName).value = list.selectedIndex;
}

//Sets selected text in a dd
Alaska.util.setSelectedText = function (listId, idx) {
    if (idx.length > 0) {
        var dd = Alaska.$(listId);
        if (dd.length > 0) {
            dd.selectedIndex = idx;
        }
    }
}

// Execute scripts
window.onload = function () {
    if (top != self) { top.location = self.location; } //Prevents XSF
    Alaska.setup();
    Alaska.drop();
    Alaska.collapse();
    Alaska.modal.init('delete-alert', 'Confirm', 'Are you sure you want to delete this alert?', 'No', 'Yes', '/flightalert/delete'); //Modified by AS

    if (Alaska.$('payment-form')) {
        Alaska.updatePaymentOptions();
    }

    if (!Alaska.$("srh-is-miles")) { //To prevent this from firing on shopping search page. This executes too late.
        if (Alaska.$('geo-from-wrap')) {
            Alaska.$('geo-from-button').addEventListener('click', Alaska.geoASPub);
        }
        if (Alaska.$('geo-to-wrap')) {
            Alaska.$('geo-to-button').addEventListener('click', Alaska.geoASPub);
        }
        if (Alaska.$('geo-to')) {
            Alaska.$('geo-to').addEventListener('keyup', Alaska.predictASPub);
        }
        if (Alaska.$('geo-from')) {
            Alaska.$('geo-from').addEventListener('keyup', Alaska.predictASPub);
        }
    }

    if (Alaska.$('bp-drop')) {
        Alaska.persistentDrop();
    }
    //Omniture needs to be at the very end of onload to prevent page lock
    if (typeof runOmni != 'undefined' && runOmni) { s.t(); }
}

// - - - - - - - - -  Additions by AS  - - - - - - - - 
// Get the XMLHTTPRequest object for AJAX
//This is from http://mobiforge.com/developing/story/getting-started-with-mobile-ajax
function getXHR() {
    if (window.XMLHttpRequest) {
        req = new XMLHttpRequest();
        return true;
    } else try {
        req = new ActiveXObject('Msxml2.XMLHTTP');
        return true;
    } catch {
        try {
            req = new ActiveXObject("Microsoft.XMLHTTP");
            return true;
        } catch {
            req = false;
            return false;
        }
    }
}

function confirmScheduleChange(lastName, reservationId, callback) {
    if (getXHR()) {
        var params = "lastName=" + lastName + "&reservationIdentifier=" + reservationId;
        req.open('POST', '/ScheduleChange/Confirm?' + params, true);
        req.onreadystatechange = function () {
            if (req.readyState !== 4) { return; }
            if (req.status === 200) {
                callback.call({}, true);
            }
            else {
                Alaska.$("client-msg-div").textContent = "We're sorry - there was a problem communicating with Alaska Airlines. Please try again or call Reservations at your convenience to confirm your trip details.";
                callback.call({}, false)
            }
        }
    }
    req.send();
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
function ToggleAllRadio() {
    var ctls = Alaska.util.getElementsByClassName('radio-controller', 'div');
    if (ctls) {
        for (var i = 0; i < ctls.length; i++) {
            var inputs = ctls[i].getElementsByTagName('input');
            if (inputs) {
                for (var j = 0; j < inputs.length; j++) {
                    if (inputs[j] && inputs[j].checked) {
                        var par = inputs[j].parentNode;
                        if (par) { if (par.click) { par.click(); } else if (par.onclick) { par.onclick(); } }
                        break;
                    }
                }
            }
        }
    }
}

function createCookie(name, value, days) {
    var expires;
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    }
    else expires = "";
    document.cookie = name + "=" + value + expires + "; path=/;secure";
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}

function areCookiesEnabled() {
    //dont change cookie name to "test". it causes errors with .net cookie check because of same name
    var r = false;
    createCookie("testing", "0", 1);
    if (readCookie("testing") != null) {
        r = true;
        eraseCookie("testing");
    }
    
    return r;
}

function GetPriorityList(url) {
    Alaska.spinner.show();
    var form = Alaska.$('prioritylist-form');
    form.setAttribute("action", url);
    form.submit();
}

function submitForm(action) {
    var form = document.forms[0];
    form.setAttribute("action", action);
    form.submit(form);
}

function GetLocalDateTime() {
    //Parses and formats the date to 1:59 am, 12/10/12	
    //var now = new Date("23:59 1/1/2012");
    var ampm = " am";
    var now = new Date();
    var day = now.getDate();
    var month = now.getMonth() + 1;
    var year = now.getFullYear().toString();
    var hour = now.getHours();
    var min = now.getMinutes();
    if (hour == 0) {
        hour = 12;
    }
    else if (hour == 12) {
        ampm = " pm";
    }
    else if (hour > 12) 
    {
        hour = hour - 12;
        ampm = " pm";
    }
    if (min < 10)
        min = "0" + min;
    var lastupd = Alaska.$('lastupdated');
    if (lastupd != null)
        lastupd.innerHTML = "Last updated: " + hour + ":" + min + " " + ampm + ", " + month + "/" + day + "/" + year.substr(2, 2);
}

// This function goes through the options for the given
// drop down box and removes them in preparation for
// a new set of values

Alaska.CitizenshipSelect = function (paxIdx, selectedValue, allowPermResCard) {
    var citDocTypeList = Alaska.$("Passengers_" + paxIdx + "__CitizenshipDocType");
    var isUS = false;
    var hasPermResOption = false;

    if (citDocTypeList != null) {
        for (var i = 0; i < citDocTypeList.length; i++) {
            if (citDocTypeList[i].value == "permanentresident") {
                hasPermResOption = true;
                if (selectedValue == "US") {
                    isUS = true;
                    citDocTypeList.remove(i);
                    break;
                }
            }
        }

        if (!isUS && !hasPermResOption && allowPermResCard == "True") {
            var option = document.createElement("option");
            option.text = "US Resident Card";
            option.value = "permanentresident";
            citDocTypeList.add(option, citDocTypeList[2]);
        }
    }
}

Alaska.CitizenshipDocTypeSelect = function (selectedValue) {
    if (selectedValue == "other") {
        Alaska.modal.addStaticModal('Airport Check-In required', 'Your international documents must be verified prior to check-in.  <br /><br />Please check in with an Alaska Airlines Customer Service Agent at the airport.');
    }
}
Alaska.CruiseLineTypeSelect = function (selectedValue) {
    if (selectedValue == "Other") {
        Alaska.$("CruiseLineNameDiv").style.display = 'block';
    }
    else {
        Alaska.$("CruiseLineNameDiv").style.display = 'none';
    }
}
Alaska.DestinationTypeSelect = function (selectedValue) {
    //State and Zip are always block
    var address = Alaska.$("USDestinationAddress_Address");
    var address1 = Alaska.$("USDestinationAddress_Address1");

    if (selectedValue == "None" || selectedValue == "Other") {
        Alaska.$("AddressDiv").style.display = 'none';
        if (address.value != "")
            address1.value = address.value;
        Alaska.$("Address1Div").style.display = 'block';
        Alaska.$("Address2Div").style.display = 'block';
        Alaska.$("CityDiv").style.display = 'block';
        Alaska.$("CruiseLineDiv").style.display = 'none';
        Alaska.$("BusinessNameDiv").style.display = 'none';
        Alaska.$("HotelNameDiv").style.display = 'none';
        Alaska.$("DepartureCityDiv").style.display = 'none';
    }
    else if (selectedValue == "Residential") {
        Alaska.$("AddressDiv").style.display = 'none';
        Alaska.$("Address1Div").style.display = 'block';
        Alaska.$("Address2Div").style.display = 'block';
        if (address.value != "")
            address1.value = address.value;
        Alaska.$("CityDiv").style.display = 'block';
        Alaska.$("CruiseLineDiv").style.display = 'none';
        Alaska.$("BusinessNameDiv").style.display = 'none';
        Alaska.$("HotelNameDiv").style.display = 'none';
        Alaska.$("DepartureCityDiv").style.display = 'none';
    }
    else if (selectedValue == "Hotel") {
        Alaska.$("HotelNameDiv").style.display = 'block';
        Alaska.$("CruiseLineDiv").style.display = 'none';
        Alaska.$("BusinessNameDiv").style.display = 'none';
        Alaska.$("AddressDiv").style.display = 'block';
        Alaska.$("Address1Div").style.display = 'none';
        Alaska.$("Address2Div").style.display = 'none';
        if (address1.value != "")
            address.value = address1.value;
        Alaska.$("CityDiv").style.display = 'block';
        Alaska.$("DepartureCityDiv").style.display = 'none';
    }
    else if (selectedValue == "Cruise") {
        Alaska.$("CruiseLineDiv").style.display = 'block';

        var dropdown = Alaska.$('USDestinationAddress_CruiseLine');
        if (dropdown.value == "Other") {
            Alaska.$("CruiseLineNameDiv").style.display = 'block'
        }

        Alaska.$("DepartureCityDiv").style.display = 'block';
        Alaska.$("BusinessNameDiv").style.display = 'none';
        Alaska.$("HotelNameDiv").style.display = 'none';
        Alaska.$("AddressDiv").style.display = 'none';
        Alaska.$("Address1Div").style.display = 'none';
        Alaska.$("Address2Div").style.display = 'none';
        Alaska.$("CityDiv").style.display = 'none';
    }
    else if (selectedValue == "Business") {
        Alaska.$("BusinessNameDiv").style.display = 'block';
        Alaska.$("CruiseLineDiv").style.display = 'none';
        Alaska.$("HotelNameDiv").style.display = 'none';
        Alaska.$("AddressDiv").style.display = 'block';
        Alaska.$("Address1Div").style.display = 'none';
        Alaska.$("Address2Div").style.display = 'none';
        if (address1.value != "")
            address.value = address1.value;
        Alaska.$("CityDiv").style.display = 'block';
        Alaska.$("DepartureCityDiv").style.display = 'none';
    }

}

Alaska.cogInfo = function () {
    Alaska.modal.addStaticModal('Notice: Change of aircraft required', 'For at least one of your flights, you must change aircraft en route even though your ticket may show only one flight number and have only one flight coupon for that flight. Further, in the case of some travel, one of your flights may not be identified at the airport by the number on your ticket, or it may be identified by other flight numbers in addition to the one on your ticket. At your request, the seller of this ticket will give you details of your change of aircraft, such as where it will occur and what aircraft types are involved.');
}

Alaska.Hazmat = function () {
    var s = 'US government regulations prohibit these hazardous materials on all aircraft. This includes items in your carry-on bags, checked bags and on your person.<br><br>Violating these regulations can result in imprisonment and heavy fines.<br><br>Alaska Airlines is required to report any hazardous materials confiscated in checked bags to the Federal Aviation Administration (FAA).<br><br>For the complete list of prohibited items, please visit faa.gov.';
    Alaska.modal.addStaticModal('Hazardous materials', s);
}

Alaska.Firearms = function () {
    var s = '<ul>If you are checking bags that contain a firearm, you cannot self-tag your bag.<br><br>Firearms in checked bags must be:<br><br>';
    s += '<li class="firearmsmodal">Declared to a Customer Service Agent</li>';
    s += '<li class="firearmsmodal">Unloaded</li>';
    s += '<li class="firearmsmodal">Locked in a hard-sided case</li><br>';
    s += 'Get more info at tsa.gov.';
    Alaska.modal.addStaticModal('Firearms restrictions', s);
}

Alaska.VerificationCodeSent = function (redirectTo, email) {
    var s = 'We have sent an email to ' + email + '.<br/><br/>Use the link in the email to update your password.<br/><br/>NOTE: The link is valid for 30 minutes.';
    Alaska.modal.addRedirectModal(redirectTo, 'Email sent', s);
}

Alaska.UserIDSent = function (redirectTo, email) {
    var s = 'Your user ID was sent to ' + email + '. You may now close this window and continue with sign in.<br/><br/>Use the password you created when you set up your My Account profile.';
    Alaska.modal.addRedirectModal(redirectTo, 'Email sent', s);
}

Alaska.PremiumClassSeatsConfirmation = function(callback) {
    
    Alaska.modal.addStaticModal(null, s); // no header
}

Alaska.Wayfinding = function (goToKiosk, goToSecurity, goToCSA) {
    var s = '<ul>';
    if (goToKiosk) {
        s += '<li class="wayfindingmodal"><b style="text-Decoration:underline;">Checking bags?</b> Print your bag tags touch-free at an airport kiosk and attach them to your bags. Our bag drop area will be nearby.</li>';
    }
    if (goToSecurity) {
        s += '<li class="wayfindingmodal"><b style="text-Decoration:underline;">No bags to check?</b> You can head straight to the security line.</li>';
    }
    if (goToCSA) {
        s += '<li class="wayfindingmodal"><b style="text-Decoration:underline;">Need help?</b> An Alaska Airlines customer service agent is standing by at the airport.</li>';
    }
    s += '<ul>';
    Alaska.modal.addStaticModal('You\'re ready to go', s);
}

function trackFullSiteLink() {
    if (s_gi) {
        var s = s_gi(s_account);
        s.linkTrackVars = 'events';
        s.linkTrackEvents = 'event19';
        s.events = 'event19';
        s.tl(this, 'o', 'Footer : Full Site');
        s.events = '';
    }
}

Alaska.Signout = function () {
    //This sets cookies with no value or expire
    document.cookie = "AuthToken=;path=/;secure";
    document.cookie = "as%5Fpers=;path=/;SameSite=Lax;secure";
    document.cookie = "DisplayName=;path=/;secure";
    if (readCookie("RememberMe") === "False") {
        document.cookie = "UserID=;path=/;secure";
    }
    if (typeof reloadOnSignOut !== 'undefined' && reloadOnSignOut) {
        window.location.reload();
    } else {
        //Swap the sign in/out divs
        Alaska.$("signin-footer-out").style.display = 'none';
        Alaska.$("signin-footer-in").style.display = 'block';
    }
}

function goBack() {
    var form = Alaska.$('back-form');
    form.submit();
    //window.location.href = document.referrer;
}